import { Component } from '@angular/core';

@Component({
  template: `
    <div
      style="display: flex; flex-direction: column; align-items: center; width 100%; padding: 200px; text-align: center;"
    >
      <mat-icon color="warn" style="width: 200px; height: 200px; font-size: 200px;">build</mat-icon>
      <h1>This page is not angular!</h1>
      <p>
        If you are developing new features for this page, consider taking the time to add it to the angular application.
        If you need this page to work, you will need to use one of the other local developent methods (
        <b>requestly</b>
        or
        <b>inv serve</b>
        ). See the
        <a href="https://github.com/vendasta/partner-center-client" target="_blank">README</a>
        for instructions.
      </p>
    </div>
  `,
  standalone: false,
})
export class EmbedLocalComponent {}
